var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "app-horizontal-layout"
    },
    [
      !_vm.session_ready
        ? [_c("preloader")]
        : [
            _c("public-invitation", {
              attrs: {
                hash: _vm.hash
              }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }